import { useSelector } from 'react-redux';
import { accountSelectors } from '../redux/modules/account';
import { Account } from '../common/types/Accounts';

export const useActiveAccount = (): Account | undefined =>
  useSelector(accountSelectors.selectActiveAccount);

export default useActiveAccount;
